 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/EBB'
 import PORT from '@/components/port'
 import LOVE1 from '@/components/love1'
 import TITLE from '@/components/Title'
 import INTRODUCTION from '@/components/Introduction'
 import STARFARERS_1231 from '@/components/Starfarers_1231'
 import STARFARERS_1245 from '@/components/Starfarers_1245'
 import STARFARERS_1232 from '@/components/Starfarers_1232'
 import STARFARERS_1233 from '@/components/Starfarers_1233'
 import STARFARERS_1234 from '@/components/Starfarers_1234'
 import STARFARERS_1235 from '@/components/Starfarers_1235'
 import STARFARERS_1236 from '@/components/Starfarers_1236'
 import STARFARERS_1237 from '@/components/Starfarers_1237'
 import STARFARERS_1238 from '@/components/Starfarers_1238'
 import STARFARERS_1239 from '@/components/Starfarers_1239'
 import STARFARERS_1240 from '@/components/Starfarers_1240'
 import STARFARERS_1241 from '@/components/Starfarers_1241'
 import STARFARERS_1242 from '@/components/Starfarers_1242'
 import STARFARERS_1243 from '@/components/Starfarers_1243'
 import STARFARERS_1244 from '@/components/Starfarers_1244'
 import STARFARERS_1246 from '@/components/Starfarers_1246'
 import STARFARERS_1248 from '@/components/Starfarers_1248'
 import STARFARERS_1262 from '@/components/Starfarers_1262'
 import STARFARERS_1249 from '@/components/Starfarers_1249'
 import STARFARERS_1250 from '@/components/Starfarers_1250'
 import STARFARERS_1251 from '@/components/Starfarers_1251'
 import STARFARERS_1252 from '@/components/Starfarers_1252'
 import STARFARERS_1253 from '@/components/Starfarers_1253'
 import STARFARERS_1254 from '@/components/Starfarers_1254'
 import STARFARERS_1255 from '@/components/Starfarers_1255'
 import STARFARERS_1256 from '@/components/Starfarers_1256'
 import STARFARERS_1257 from '@/components/Starfarers_1257'
 import STARFARERS_1258 from '@/components/Starfarers_1258'
 import STARFARERS_1259 from '@/components/Starfarers_1259'
 import STARFARERS_1260 from '@/components/Starfarers_1260'
 import STARFARERS_1261 from '@/components/Starfarers_1261'
 import STARFARERS_1263 from '@/components/Starfarers_1263'
 import LOVE2 from '@/components/love2'
 import ABA from '@/components/aba'
 import COPYRIGHT from '@/components/copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/EBB",
 			"name" : "EBB",
 			"component" : EBB
 		},
 		{
 			"path" : "/port",
 			"name" : "port",
 			"component" : PORT
 		},
 		{
 			"path" : "/love1",
 			"name" : "love1",
 			"component" : LOVE1
 		},
 		{
 			"path" : "/Title",
 			"name" : "Title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/Introduction",
 			"name" : "Introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/Starfarers_1231",
 			"name" : "Starfarers_1231",
 			"component" : STARFARERS_1231
 		},
 		{
 			"path" : "/Starfarers_1245",
 			"name" : "Starfarers_1245",
 			"component" : STARFARERS_1245
 		},
 		{
 			"path" : "/Starfarers_1232",
 			"name" : "Starfarers_1232",
 			"component" : STARFARERS_1232
 		},
 		{
 			"path" : "/Starfarers_1233",
 			"name" : "Starfarers_1233",
 			"component" : STARFARERS_1233
 		},
 		{
 			"path" : "/Starfarers_1234",
 			"name" : "Starfarers_1234",
 			"component" : STARFARERS_1234
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js